import { ColumnDef } from "@tanstack/react-table";
import { z, ZodObject, ZodRawShape } from "zod";
import { useTranslation } from "react-i18next";
import { PositionTireSetsCol } from "../../modules/features/PositionTireSetsCol";

export const PositionTableColumns: ColumnDef<
  z.infer<ZodObject<ZodRawShape>>
>[] = [
  {
    accessorKey: "position",
    header: "position",
  },
  {
    id: "shelvingUnit.identifier",
    accessorKey: "shelvingUnit.identifier",
    header: "Shelving unit",
  },
  {
    id: "shelvingUnit.path.warehouse.name",
    accessorKey: "shelvingUnit.path.warehouse.name",
    header: "warehouse",
  },
  {
    id: "shelvingUnit.path.warehouse.status",
    accessorKey: "shelvingUnit.path.warehouse.status",
    header: "status",
    cell: ({ row }) => {
      const { t } = useTranslation("common");

      if (row.original.shelvingUnit?.path?.warehouse.status === true) {
        return t("Active");
      }

      return t("Inactive");
    },
  },
  {
    enableSorting: false,
    accessorKey: "shelvingUnit.path.tiresets",
    header: "Tireset",
    meta: {
      columnAction: "",
    },
    cell: ({ row }) => {
      const { t } = useTranslation("common");

      return <PositionTireSetsCol row={row} t={t} />;
    },
  },
];
